<emm-progress-bar [isLoading$]="isLoading$"></emm-progress-bar>
<emm-attributes-header
    *ngIf="item$ | async as item"
    [countryCode]="countryCode"
    [disabledCode]="item['disabledCode']"
    [disabledSystem]="item['disabledSystem']"
    [disabledSource]="item['disabledSource']"
    [name]="item.name"
    [tag]="item.tag"
    [type]="item['typeName']"
    [subType]="item['itemSubType']"
    [featureScope]="scope"
></emm-attributes-header>
<div class="form-content" *ngIf="renderForm | async">
    <main *ngIf="item$ | async as item" [style.width]="rightPaneWidth">
        <emm-attributes-form
            [rightPaneWidth]="rightPaneWidth"
            [attributeGroups]="attributeGroups"
            [attributesByGroup]= "attributesByGroup"
            [form]="form | async"
            [item]="item"
            [selectedSubmenu]="selectedSubmenu$ | async"
            [isReadOnly$]="isReadOnly$"
            [model]="valuesObservable | async"
            [options]="options"
            [featureScope]="scope"
            [menuParams]="menuParamsContext$ | async"
            [effectiveDate]="effectiveDate | async"
            [nodeId]="item.id"
            [selectedFeatureScope$]="selectedFeatureScope$"
            [dialogService]="dialogService"
            [locationSet]="locationSet"
            [itemNode]="itemNode"
            [isSubMenu]="isSubMenu"
            [language]="language$ | async"
            [previousAttributeGroups]="previousAttributeGroups$ | async"
            (attributeGroupSelected)="onAttributeGroupSelected($event)"
            (submenuRenamed)="onSubmenuRenamed($event)"
        ></emm-attributes-form>
        <div></div>
        <div></div>
    </main>
</div>
